var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60035 9.52393H17.4003M6.60035 9.52393C6.04029 9.52393 5.75957 9.52393 5.54566 9.63292C5.3575 9.72879 5.20463 9.88166 5.10875 10.0698C4.99976 10.2837 4.99976 10.564 4.99976 11.124V16.324C4.99976 17.4441 4.99976 18.0043 5.21775 18.4321C5.40949 18.8084 5.71523 19.1144 6.09156 19.3062C6.51896 19.5239 7.07875 19.5239 8.19667 19.5239H15.8025C16.9204 19.5239 17.4794 19.5239 17.9068 19.3062C18.2831 19.1144 18.5902 18.8084 18.782 18.4321C18.9998 18.0046 18.9998 17.4456 18.9998 16.3276V11.1149C18.9998 10.5609 18.9998 10.2826 18.8914 10.0698C18.7955 9.88166 18.6419 9.72879 18.4538 9.63292C18.2398 9.52393 17.9604 9.52393 17.4003 9.52393M6.60035 9.52393H4.97507C4.12597 9.52393 3.70168 9.52393 3.4607 9.37549C3.13911 9.1774 2.95678 8.81472 2.98902 8.4384C3.0132 8.15616 3.26593 7.81481 3.77222 7.13132C3.91866 6.93363 3.99189 6.83476 4.08152 6.75928C4.20104 6.65863 4.34286 6.58715 4.49488 6.55102C4.60889 6.52393 4.73126 6.52393 4.9773 6.52393H19.0217C19.2677 6.52393 19.3904 6.52393 19.5044 6.55102C19.6564 6.58715 19.7982 6.65863 19.9177 6.75928C20.0074 6.83476 20.0809 6.93317 20.2273 7.13086C20.7336 7.81434 20.9867 8.1561 21.0109 8.43834C21.0432 8.81466 20.8602 9.1774 20.5386 9.37549C20.2976 9.52393 19.8723 9.52393 19.0232 9.52393H17.4003M9.99976 14.5239H13.9998",
    stroke: "#616161",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCms);
export default __webpack_public_path__ + "static/media/iconCMS.ebb651202e935f7318bc6c75d6ba900d.svg";
export { ForwardRef as ReactComponent };